import React from "react";
import { deleteMain, getSizes } from "../../api";
import { Await, defer, useLoaderData } from "react-router-dom";
import DataGrid, { image } from "../../Component/DataGrid";
import ActionButton from "../../Component/ActionButton";
import UtilitesModal from "./Modal/UtilitesModal";

export const loader = ({ request }) => {
  const url = new URL(request.url);
  const sort = url.searchParams.get("sort");
  const order = url.searchParams.get("order");
  const search = url.searchParams.get("search");

  const PromisedData = getSizes(sort, order, search, "Group", "", "Discount");
  return defer({ data: PromisedData });
};

export default function Discount() {
  const data = useLoaderData();
  const [actionData, setActionData] = React.useState({});
  const Actions = (p) => {
    return (
      <div className="d-flex h-100 justify-content-center align-items-center gap-2">
        <ActionButton
          modal="utlitiesModal"
          setActionData={setActionData}
          p={p}
        />
        <ActionButton
          p={p}
          isDelete={true}
          deleteFunc={deleteMain}
          deletePaymentType="Group"
        />
      </div>
    );
  };
  const [colDefs, setColDefs] = React.useState([
    {
      headerName: "name",
      cellRenderer: image,
    },

    {
      field: "kuName",
      headerName: "kurdishName",
    },
    {
      field: "arName",
      headerName: "arabicName",
    },

    {
      field: "actions",
      cellRenderer: Actions,
    },
  ]);
  return (
    <section className="p-3">
      <React.Suspense
        fallback={
          <div className="w-100 h-screen d-flex justify-content-center align-items-center">
            <span className="loader-admin">Loading</span>
          </div>
        }
      >
        <Await resolve={data.data}>
          {(data) => {
            return (
              <DataGrid
                modalType={"utlitiesModal"}
                setActionData={setActionData}
                hasCreate={true}
                data={data}
                rowHeight={80}
                col={colDefs}
              />
            );
          }}
        </Await>
      </React.Suspense>

      <UtilitesModal actionData={actionData} type="Discount" />
    </section>
  );
}
